<template>
  <img :src="imageSrc" :alt="alt" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useColorMode } from '@vueuse/core';

type ImagePropsType = {
  src: string;
  alt: string;
  // Optional file format for theme variants (`{src}_dark|light.{format}`).
  // Defaults to `svg` so existing call sites keep working without passing format.
  format?: 'svg' | 'png';
};

const props = withDefaults(defineProps<ImagePropsType>(), {
  format: 'svg',
});

const colorMode = useColorMode();

const imageSrc = computed(() => {
  const theme = colorMode.value === 'dark' ? 'dark' : 'light';
  return new URL(
    `../assets/images/${props.src}_${theme}.${props.format}`,
    import.meta.url
  ).href;
});
</script>
